module.exports = __webpack_public_path__ + "media/images/winner--right-2441f3886e2b8e2d01ba28d2e9c8c388.png";